module.exports = __webpack_public_path__ + "img/7.09a8b4f4.png";